export default "__VITE_ASSET__OhD3M6Ex__"